import { useCallback, useState } from "react";
import { getToken } from "../../services/login";

const { REACT_APP_API_BASE_URL } = process.env;

export interface UseCaptchaResult {
  uid: string;
  captchaSrc: string;
  refreshCaptcha: () => void;
}

export function useCaptcha(): UseCaptchaResult {
  const [captchaSrc, setCaptchaSrc] = useState<string>("");
  const [uid, setUid] = useState<string>("");

  const refreshCaptcha = useCallback(() => {
    getToken().then((res) => {
      const { token, uid } = res?.data;
      setUid(uid);
      setCaptchaSrc(
        `${REACT_APP_API_BASE_URL}/webdata/user/ValidCodeImageCus.aspx?uid=${uid}&token=${token}`
      );
    });
  }, []);

  return {
    uid,
    captchaSrc,
    refreshCaptcha,
  };
}
